import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { intl } from './../../../core/globalIntl';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import * as Render from './../../../lib/render';
import * as Validator from './../../../lib/validate';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


const styles = theme => ({
  root: {
    display: 'flex',
  },
  container: {
    width: '100%',
    padding: '0 12px 0 12px',
  },
  explanation:{
    fontSize: 25,
    textAlign: 'center',
    whiteSpace: "pre-line",
    padding: '20px 10px 10px 10px'
  },
  text2:{
    fontSize: 20,
    textAlign: 'center',
  },
  text3:{
  	fontWeight : "bold",
  },
  textCenter: {
    textAlign: 'center',
    padding: '20px'
  },
  fontBlue: {
    color: '#0000FF',
  }
});

class InfoaddSelect extends React.Component {

  doFirstEntry = async() => {
    
    this.props.doSetEntryKubun(1);
    console.log("########################"+await this.props.doGetEntryKubun());
    //入所画面に移動（初めて）
    this.props.history.push('./Infoadd');
  };
  
  doSecondEntry = async() => {
    
    this.props.doSetEntryKubun(2);
    console.log("########################"+await this.props.doGetEntryKubun());
    //入所画面に移動（入所済み）
    this.props.history.push('./Infoadd');
  };

  render() {
    const { classes, handleSubmit } = this.props;
    
    return (
      <div className={classes.root}>
       <CssBaseline />
        <Grid container className={classes.container} spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} sm={12} className={classes.explanation}>
            <span className={classes.fontBlue}>
              避難所への入所受付
            </span>
            <span>
              を行います
            </span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.text2}>
            <span>
              避難所名：{this.props.shelterName}
            </span>
          </Grid>
          <Grid item xs={12} sm={12}>
            <span className={classes.text3}>
              ●初めて入所する方はこちらのボタンを押して世帯情報を入力してください
            </span>
          </Grid>
          <Grid item xs={12} className={classes.textCenter}>
            <Button
              id="btnDialg"
              variant="contained"
              color="primary"
              onClick={this.doFirstEntry}
              className={classes.button}
              size="large"
            >  
              <span>初めて入所<br/>（世帯情報入力）</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={12}>
            <span className={classes.text3}>
              ●入所済みで同世帯者情報を追加する場合はこちらの<br/>ボタンを押して世帯主もしくは家族のQRコードを読み込んでください

            </span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.textCenter}>
            <Button
              id="btnGet"
              variant="contained"
              color="primary"
              onClick={this.doSecondEntry}
              className={classes.button}
              size="large"
            >  
              <span>同世帯者を追加登録<br/>（世帯情報確認）</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={12}></Grid>


        </Grid>


      </div>
    );
  }
}

const FORM_NAME = "infoaddSelect";

const mapStateToProps = state => ({
  values: getFormValues(FORM_NAME)(state),
  shelterName: state.infoaddSelect.shelterName,
  entryKubun: state.infoaddSelect.entryKubun
});

const mapDispatchToProps = {
};

InfoaddSelect = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(InfoaddSelect));

InfoaddSelect.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(InfoaddSelect));